/* @flow */

export const MARK_CHECK_IN_ANIMATION_AS_RUNNING =
  'MARK_CHECK_IN_ANIMATION_AS_RUNNING';
export const MARK_CHECK_IN_ANIMATION_AS_DONE =
  'MARK_CHECK_IN_ANIMATION_AS_DONE';

export const MARK_CHECK_IN_TAKE_OVER_AS_OPEN =
  'MARK_CHECK_IN_TAKE_OVER_AS_OPEN';
export const MARK_CHECKIN_TAKE_OVER_AS_CLOSED =
  'MARK_CHECKIN_TAKE_OVER_AS_CLOSED';
